import {
  View,
  Text,
  Image,
  Dimensions,
  TouchableOpacity,
  TextInput,
  KeyboardAvoidingView,
} from "react-native";
import React, { useEffect } from "react";
import MyView from "../../components/custom/MyView";
import { kalbasiMaybe, lightBlue, lighterBlue, white } from "../../colors";
import {
  consultationDoctor,
  consultationNotAvailable,
  height,
  kidsWithDoctor,
  width,
} from "../../imports";
import MyText from "../../components/custom/MyText";
import { RefreshControl, ScrollView } from "react-native-gesture-handler";
import WelcomeUser from "../../components/home/WelcomeUser";
import translate from "../../functions/translate";
import Wallet from "../../components/home/Wallet";
import GrowTest from "../../components/home/GrowTest";
import ASQ3Test from "../../components/home/ASQ3Test";
import ASQSE2Test from "../../components/home/ASQSE2Test";
import ADHDTest from "../../components/home/ADHDTest";
import LearningSlider from "../../components/home/LearningSlider";
import { useDispatch, useSelector } from "react-redux";
import { changeHeaderColor } from "../../redux/header/headerAction";
import { useIsFocused } from "@react-navigation/native";
import SelectIcon from "../../assets/svg/SelectIcon";
import MyButton from "../../components/custom/MyButton";
import { LinearGradient } from "expo-linear-gradient";
import SectionDropdown from "../../components/custom/SectionDropdown";
import { AntDesign } from "@expo/vector-icons";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Dropdown from "../../components/custom/Dropdown";
import DoctorCard from "../../components/consultation/DoctorCard";
import SelectMyChildren from "../../components/custom/SelectChildren";
import { useState } from "react";
import childrenList from "../../api/get/childrenList";
import { refresh } from "../../redux/main/mainAction";
import LoginFirst from "../../components/custom/LoginFirst";

export default function SelectChildren({ changed }) {
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lighterBlue));
    }
  }, [isFocused]);

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      refreshControl={
        <RefreshControl
          refreshing={false}
          onRefresh={() => {
            dispatch(refresh());
          }}
        />
      }
      style={{ width: "100%", flex: 1 }}
      contentContainerStyle={{ alignItems: "center" }}
    >
      <View
        style={{
          height: height,
          width: width,
          backgroundColor: lighterBlue,
          marginTop: -1 * height,
          display: "flex",
        }}
      ></View>
      <View
        style={{
          alignItems: "center",
          flex: 1,

          backgroundColor: lighterBlue,
        }}
      >
        <View style={{ backgroundColor: lighterBlue }}>
          <View
            style={{
              backgroundColor: lighterBlue,
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              width: Dimensions.get("screen").width,
              minHeight: 200,
              flexDirection: "row",
              paddingHorizontal: 10,
            }}
          >
            <View style={{ flex: 5 }}>
              <View>
                <MyText
                  style={{
                    fontSize: 32,
                    marginHorizontal: 10,
                    color: "#504E4E",
                  }}
                >
                  {translate("consultation and help")}
                </MyText>
              </View>
            </View>
            <View style={{ flex: 3 }}>
              <Image
                source={consultationDoctor}
                style={{ width: "100%", height: 320 }}
                resizeMode="contain"
              />
            </View>
          </View>
        </View>
        {/* <View
          style={{
          
            width: "100%",
            height: height,
            backgroundColor: lighterBlue,
          }}
        >
          <MyText style={{ fontSize: 23, color: "#555"}}>
            {translate("We are sorry, This item isn't available for now !")}
          </MyText>
        </View> */}
      </View>

      {main.token !== null && (
        <View style={{ marginTop: 30, width: "94%" }}>
          <SelectMyChildren isFocused={isFocused} />
        </View>
      )}
      <View>{main.token === null && <LoginFirst />}</View>
      <View style={{ height: 100 }}></View>
    </ScrollView>
  );
}
